import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { phoneOptionActions } from './phone-option.actions';
import { phoneOptionSelectors } from './phone-option.reducer';

@Injectable({ providedIn: 'root' })
export class PhoneOptionEffects {
   defaultFields: string[] = [
      'phoneId',
      'phoneType',
      'extensionId',
      'sipUsers.sipUserId',
      'sipUsers.userName',
      'devices.deviceId',
      'devices.macAddress',
   ];

   defaultOrderingOptions: string[] = ['phoneId:asc'];

   staticFilters: string[] = ['extensionId = extensionId'];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      phoneOptionSelectors.selectState,
      'phones?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      phoneOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
